export const clearInput = (event: any) => event.target.value = '';
